import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CostTrackerEffect } from "./effect";
import { CostTrackerReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([CostTrackerEffect]),
        StoreModule.forFeature('costTracker', CostTrackerReducer)
    ]
})

export class CostTrackerStoreModule { }

export const costTrackersList = (store: any) => store && store.costTracker && store.costTracker.costTrackersList;
export const costTrackersByFieldList = (store: any) => store && store.costTracker && store.costTracker.costTrackersByFieldList;
export const costTrackerById = (store: any) => store && store.costTracker && store.costTracker.costTrackerById;
export const cloudProvidersList = (store: any) => store && store.costTracker && store.costTracker.cloudProvidersList;
export const saveCostTrackerResp = (store: any) => store && store.costTracker && store.costTracker.saveCostTrackerResp;
export const deleteCostTrackerResp = (store: any) => store && store.costTracker && store.costTracker.deleteCostTrackerResp;
export const costTrackerContracts = (store: any) => store && store.costTracker && store.costTracker.costTrackerContracts;

// events
export const eventsForTracker = (store: any) => store && store.costTracker && store.costTracker.eventsForTracker;
export const addEventResp = (store: any) => store && store.costTracker && store.costTracker.addEventResp;
export const saveEventResp = (store: any) => store && store.costTracker && store.costTracker.saveEventResp;
